import { useEffect, useState } from 'react';
import { VideoCamera } from '@phosphor-icons/react';

type MediaSelectionPreviewProps = {
  item: File | { url: string; type?: string; name?: string };
};

export default function MediaSelectionPreview({ item }: MediaSelectionPreviewProps) {
  const [previewUrl, setPreviewUrl] = useState('url' in item ? item.url : '');
  const type = item.type || '';

  useEffect(() => {
    if ('url' in item) {
      setPreviewUrl(item.url);
      return undefined;
    }

    const objectUrl = URL.createObjectURL(item);
    setPreviewUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [item]);

  if (!previewUrl) return null;

  if (type.startsWith('video/')) {
    return (
      <span className="attachment-media-preview video">
        <video src={previewUrl} muted playsInline />
        <VideoCamera weight="fill" />
      </span>
    );
  }

  return <img className="attachment-media-preview" src={previewUrl} alt={item.name || ''} />;
}
